(() => {
  function init(root) {
    if (root.dataset.editorialReady) return;
    root.dataset.editorialReady = 'true';
    const entries = [...root.querySelectorAll('[data-editorial-entry]')];
    const buttons = [...root.querySelectorAll('[data-editorial-filter]')];
    const count = root.querySelector('[data-editorial-count]');
    const empty = root.querySelector('[data-editorial-empty]');
    let category = 'all';
    let month = 'all';
    function apply() {
      let visible = 0;
      entries.forEach(entry => {
        const match = (category === 'all' || entry.dataset.category === category) && (month === 'all' || entry.dataset.month === month);
        entry.hidden = !match;
        if (match) {visible++; const number = entry.querySelector('[data-editorial-number]'); if (number) number.textContent = String(visible).padStart(2, '0');}
      });
      if (count) count.textContent = (visible === 1 ? count.dataset.singular || count.dataset.template : count.dataset.template).replace('__COUNT__', visible);
      if (empty) empty.hidden = visible !== 0;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.editorialFilter === 'month' ? button.dataset.value === month : button.dataset.value === category)));
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      if (button.dataset.editorialFilter === 'month') month = button.dataset.value;
      else {category = button.dataset.value; if (category === 'all') month = 'all';}
      apply();
    }));
    apply();
  }
  document.querySelectorAll('[data-editorial-filterable]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-editorial-filterable]').forEach(init));
})();
